import React, { ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Autoplay } from 'swiper'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import { IBannerList } from 'Pages/home/banner'

SwiperCore.use([Navigation, Autoplay])

export interface SwiperProps {
  frameTimes: number
  imgArray?: string[]
  children?: ReactNode
  setSlideIndex?: (x: number) => void
  onShowSlide?: (x: number) => void
  onClickSlide?: (x: number) => void
}

const default_img = require('static/default2.png')
const LiveSwiper = (props: SwiperProps) => {
  const {
    children,
    setSlideIndex,
    imgArray = [default_img],
    onShowSlide,
    onClickSlide,
  } = props

  return (
    <>
      {imgArray.length > 1 ? (
        <Swiper
          spaceBetween={16}
          navigation={{
            nextEl: '.live-swiper-next',
            prevEl: '.live-swiper-prev',
          }}
          loop={imgArray.length > 1}
          watchOverflow={true}
          simulateTouch={false}
          autoplay={{ disableOnInteraction: false, delay: 3000 }}
          onSlideChangeTransitionStart={swiper => {
            setSlideIndex && setSlideIndex(swiper.realIndex)
            onShowSlide && onShowSlide(swiper.realIndex)
          }}
        >
          {imgArray.map((e, index) => (
            <SwiperSlide key={e}>
              <img
                src={e}
                className="banner-img"
                onClick={e => {
                  onClickSlide && onClickSlide(index)
                }}
              />
            </SwiperSlide>
          ))}
          <span className="swiper-nav-pre live-swiper-prev" />
          <span className="swiper-nav-next live-swiper-next" />
        </Swiper>
      ) : (
        <img
          src={imgArray[0]}
          className="banner-img"
          onClick={e => {
            onClickSlide && onClickSlide(0)
          }}
        />
      )}

      {children}

      <style jsx>
        {`
          .banner-img {
            object-fit: cover;
            object-position: top;
            width: 800px;
            height: 325px;
            background-color: rgba(0, 0, 0, 0.08);
            vertical-align: bottom;
          }

          :global(.noshow) {
            display: none;
          }
          :global(.swiper-button-disabled) {
            display: none;
          }
        `}
      </style>
    </>
  )
}

interface BannerData extends IBannerList {
  user_info?: {
    user_id?: string
  }
}

const transit = (props: {
  bannerData: BannerData[]
  setSlideIndex: (x: number) => void
}) => {
  const { bannerData, setSlideIndex } = props
  const imgArray = useMemo(() => bannerData.map(e => e.img_url), [bannerData])
  return (
    <LiveSwiper
      imgArray={imgArray}
      frameTimes={bannerData.length || 1}
      onShowSlide={(x: number) => {
        setSlideIndex(x)
        sendTeaCommEvent('show_home_live_top_banner', {
          rank: x,
          anchor_id: bannerData[x]?.user_info?.user_id || '',
          room_id: bannerData[x]?.gid,
        })
      }}
      onClickSlide={(x: number) => {
        sendTeaCommEvent('click_home_live_top_banner', {
          rank: x,
          anchor_id: bannerData[x]?.user_info?.user_id || '',
          room_id: bannerData[x]?.gid,
        })
      }}
    />
  )
}

export default transit
